"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
var giveback = {
	app: {
		config: {
			apiKey: "AIzaSyCGsDX1a46bM6H7RNS-M2U8UjNuLs8bsAE",
			authDomain: "parks-project-f522c.firebaseapp.com",
			databaseURL: "https://parks-project-f522c.firebaseio.com",
			projectId: "parks-project-f522c",
			storageBucket: "parks-project-f522c.appspot.com",
			messagingSenderId: "534762130684",
			appId: "1:534762130684:web:a1e008e3079d5570749b79"
		},
		init: function init() {

			try {
				firebase.initializeApp(giveback.app.config);
				giveback.app.db = firebase.database();
				console.log('Initialize Firebase.');
			} catch (err) {
				console.log('could not initialize firebase app. Fall back.');
			}
		}
	},
	init: function init() {
		if (sessionStorage.getItem('giveback')) {
			giveback.amount = JSON.parse(sessionStorage.getItem('giveback'));
			Neptune.liquid.load('giveback');
		}
		giveback.app.init();
		giveback.app.db.ref("giveback").on('value', function (data) {
			var update = data.val();
			giveback.amount = {
				was: giveback.amount,
				value: update,
				string: Math.round(update).toLocaleString(),
				char: Math.round(update).toLocaleString().split('')
			};
			sessionStorage.setItem('giveback', JSON.stringify(giveback.amount));
			Neptune.liquid.load('giveback');
		});
	}
};
window.giveback = giveback;
exports.default = giveback;